import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import ProgressivePhoto from '../../../../../../../../../../../components/grid/ProgressivePhoto';
import { IMAGE_SIZE_CODE } from '../../../../../../../../../../../constants/image-size-codes';
import InvisibleIcon from '../../../../../../../../../../../components/icons/InvisibleIcon';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  linkTo: PropTypes.string.isRequired,
  isHidden: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
const Photo = ({ photo, linkTo, isHidden, children }) => {
  const classes = classNames({
    'secondary-photos-view-photos-step-photo': true,
    hidden: isHidden,
  });

  return (
    <div className={classes}>
      {isHidden && (
        <div className="hidden-icon">
          <InvisibleIcon color="#fff" size={32} />
        </div>
      )}
      <Link to={linkTo}>
        <ProgressivePhoto
          thumbnails={photo.watermarked_urls || photo.thumbnail_urls}
          progressive={false}
          size={IMAGE_SIZE_CODE.MEDIUM2X}
          allowFallbackThumbnail
        />
      </Link>
      {children}
    </div>
  );
};

Photo.propTypes = propTypes;

export default Photo;
